import { createContext } from 'react';

export const LocaleContext = createContext({});